var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M16.708 11.296 10.71 5.293a1.007 1.007 0 0 0-1.419 0 1.01 1.01 0 0 0 0 1.42l5.297 5.293L9.292 17.3a.997.997 0 0 0 .71 1.701c.26 0 .51-.1.71-.29l5.996-5.993a.997.997 0 0 0 0-1.411v-.01Z"
  })));
};
export default SvgArrowRight;